// extracted by extract-css-chunks-webpack-plugin
module.exports = {"closeButton":"app-pages-onboard--closeButton"};